export default __webpack_public_path__ + "static/media/lineF2pt.1148cfbe.png";